import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { BusinessListComponent } from './components/business-list/business-list.component';
import { ManageBusinessEntityComponent } from './components/manage-business-entity/manage-business-entity.component';
import { FinancialReportGuard } from './guards/financial-report.guard';
import { SysadminGuard } from './guards/sysadmin.guard';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { authenticatedGuard } from './guards/authenticated.guard';
import { environment } from '../environments/environment';

const routes: Routes = [
  { path: '', component: DashboardComponent },
  { path: 'login', component: DashboardComponent },
  { path: 'business-list', component: BusinessListComponent },
  {
    path: 'manage-business-entity/:id',
    component: ManageBusinessEntityComponent
  },
  {
    path: 'services/:id',
    loadChildren: () =>
      import('./components/form/form.module').then((m) => m.FormModule)
  },
  {
    path: 'part-b/:serviceId/:roleName/:processId',
    loadChildren: () =>
      import('./components/form/form.module').then((m) => m.FormModule)
  },
  {
    path: 'part-b',
    loadChildren: () =>
      import('./components/part-b/part-b.module').then((m) => m.PartBModule)
  },
  {
    path: 'inspector/:serviceId/:roleName/:processId',
    loadChildren: () =>
      import('./components/form/form.module').then((m) => m.FormModule)
  },
  {
    path: 'inspector',
    loadChildren: () =>
      import('./components/inspector/inspector.module').then(
        (m) => m.InspectorModule
      )
  },
  {
    path: 'admin/users',
    loadChildren: () =>
      import('./components/user-management/user-management.module').then(
        (m) => m.UserManagementModule
      ),
    canActivate: [SysadminGuard]
  },
  {
    path: 'financial-report',
    loadChildren: () =>
      import('./components/financial-report/financial-report.module').then(
        (m) => m.FinancialReportModule
      ),
    canActivate: [FinancialReportGuard]
  },
  ...(environment.KEYCLOAK_ACTIVE
    ? [
        {
          path: 'user/change-password',
          component: ChangePasswordComponent,
          canActivate: [authenticatedGuard]
        }
      ]
    : []),
  { path: '**', component: DashboardComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
      useHash: false
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
